<template>
    <Datepicker
        ref="picker"
        v-model="valueModel"
        :name="mergedOptions.name"
        :id="mergedOptions.id"
        :format="mergedOptions.format"
        :language="mergedOptions.language"
        :disabledDates="mergedOptions.disabledDates"
        :placeholder="mergedOptions.placeholder"
        :inline="mergedOptions.inline"
        :inputClass="mergedOptions.inputClass"
        :mondayFirst="mergedOptions.mondayFirst"
        :required="mergedOptions.required"
        :typeable="mergedOptions.typeable"
        :disabled="mergedOptions.disabled"
        :clear-button="mergedOptions.clearButton"
        :clear-button-icon="mergedOptions.clearButtonIcon"
    >
    </Datepicker>
</template>

<script>
//https://www.npmjs.com/package/vuejs-datepicker#demo

import _ from 'lodash';

//Mixins
import cultureMixin from '@core/Util/Mixins/culture';
import resourceMixin from '@core/Util/Mixins/resources';
import guidMixin from '@core/Util/Mixins/guid';

//Components
import Datepicker from '../../../Vendor/vuejs-datepicker/index';
import {en, nl} from '../../../Vendor/vuejs-datepicker/locale';

export default {
    name: 'date-picker',
    
    mixins: [cultureMixin, resourceMixin, guidMixin],
    
    components: {
        Datepicker
    },

    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: Date|String,
            required: true
        }
    },
    
    data() {
        const vm = this;
        const id = vm.guid();
        const culture = vm.culture().name;

        return {
            defaultOptions: {
                name: `datepicker-${id}`,
                id: `datepicker-${id}`,
                format: 'dd-MM-yyyy',
                language:  culture === 'nl' ? nl : en,
                disabledDates: {
                    to: undefined, //Date objects
                    from: undefined
                },
                placeholder: vm.resource('DatePicker_Placeholder'),
                inline: false,
                inputClass: 'form-control datepicker',
                mondayFirst: true,
                required: false,
                typeable: true,
                disabled: false,
                clearButton: false,
                clearButtonIcon: undefined
            },
            // newValue: null
        };
    },

    computed: {
        mergedOptions() {
            const vm = this;
            return _.merge({}, vm.defaultOptions, vm.options);
        },

        valueModel: {
            get() {
                return this.value;
            },
            set(value) {
                //this.newValue = value;
                this.$emit('input', value);
            }
        }
    }
};
</script>

<style lang="scss" scoped src="./Styles/date-picker.scss">
    
</style>